"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _Paper = _interopRequireDefault(require("material-ui/Paper"));

var _RaisedButton = _interopRequireDefault(require("material-ui/RaisedButton"));

var _expanderAnnouncementReview = _interopRequireDefault(require("../expanderAnnouncementReview"));

var _RepeaterReview = _interopRequireDefault(require("../RepeaterReview"));

var _reactTruncate = _interopRequireDefault(require("react-truncate"));

var _utils = require("../../../../lib/utils");

var _noPhoto2x = _interopRequireDefault(require("../../../../images/no-photo@2x.png"));

var _smallCircleCheck2x = _interopRequireDefault(require("../../../../images/small-circle-check@2x.png"));

require("../../../../sass/components/shared/elements/dashCompanyRegistration/ReviewSection.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ReviewSection = /*#__PURE__*/function (_React$Component) {
  _inherits(ReviewSection, _React$Component);

  var _super = _createSuper(ReviewSection);

  function ReviewSection() {
    var _this;

    _classCallCheck(this, ReviewSection);

    _this = _super.call(this);
    _this.handleAnalytics = _this.handleAnalytics.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ReviewSection, [{
    key: "handleAnalytics",
    value: function handleAnalytics(label) {
      label && (0, _utils.googleAnalytics)(label)();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          reviewClass = _this$props.reviewClass,
          emptyTruncatedStyling = _this$props.emptyTruncatedStyling,
          hideCheckmark = _this$props.hideCheckmark,
          title = _this$props.title,
          type = _this$props.type,
          bodyEmphasis = _this$props.bodyEmphasis,
          expanderSubtitle = _this$props.expanderSubtitle,
          body = _this$props.body,
          image = _this$props.image,
          editFunct = _this$props.editFunct,
          repeaterArray = _this$props.repeaterArray,
          repeaterIcon = _this$props.repeaterIcon,
          analyticsLabel = _this$props.analyticsLabel;
      /*type may be 'standard', 'no-photo', 'truncated', 'repeater', or 'expander'*/

      return /*#__PURE__*/_react.default.createElement("div", {
        className: reviewClass ? "review-section-container ".concat(reviewClass) : 'review-section-container'
      }, !hideCheckmark && /*#__PURE__*/_react.default.createElement("img", {
        src: _smallCircleCheck2x.default,
        alt: "green checkmark reassures that you have completed this section",
        className: "review-green-check"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "review-section-right"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "review-section-title"
      }, title), type === 'standard' && /*#__PURE__*/_react.default.createElement("div", {
        className: "review-section-body"
      }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
        className: "photo-upload-viewer",
        zDepth: 1,
        rounded: false,
        style: {
          backgroundImage: "url(".concat(image, ")")
        }
      }, !image && /*#__PURE__*/_react.default.createElement("img", {
        src: _noPhoto2x.default,
        className: "photo-upload-viewer-blank",
        alt: "No Image Uploaded"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "review-body-text"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "review-body-emphasis"
      }, bodyEmphasis), body)), type === 'no-photo' && /*#__PURE__*/_react.default.createElement("div", {
        className: "review-body-text"
      }, !!bodyEmphasis && /*#__PURE__*/_react.default.createElement("p", {
        className: "review-body-emphasis"
      }, bodyEmphasis), body), type === 'truncated' && /*#__PURE__*/_react.default.createElement("div", {
        className: "review-section-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "review-body-text"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "review-body-emphasis"
      }, bodyEmphasis), /*#__PURE__*/_react.default.createElement(_reactTruncate.default, {
        className: emptyTruncatedStyling ? 'empty-repeater-text' : '',
        lines: 3,
        ellipsis: /*#__PURE__*/_react.default.createElement("span", null, "...")
      }, body))), type === 'expander' && /*#__PURE__*/_react.default.createElement(_expanderAnnouncementReview.default, {
        bodyEmphasis: bodyEmphasis,
        expanderSubtitle: expanderSubtitle,
        image: image,
        editFunct: editFunct,
        body: body
      }), type === ('repeater' || '') && /*#__PURE__*/_react.default.createElement("div", {
        className: "review-section-body repeater-review-body"
      }, /*#__PURE__*/_react.default.createElement(_RepeaterReview.default, {
        repeaterArray: repeaterArray,
        repeaterIcon: repeaterIcon
      }))), type !== 'expander' && /*#__PURE__*/_react.default.createElement(_RaisedButton.default, {
        label: "Edit",
        className: "announcement-edit-button",
        onClick: function onClick(e) {
          editFunct();

          _this2.handleAnalytics(analyticsLabel);
        },
        labelStyle: {
          textTransform: 'none'
        },
        style: {
          marginLeft: 'auto',
          marginTop: '0',
          position: 'absolute',
          right: '2rem',
          top: '1.5rem',
          minWidth: '10rem'
        }
      }));
    }
  }]);

  return ReviewSection;
}(_react.default.Component);

exports.default = ReviewSection;